import { Route, Switch, Redirect } from 'react-router-dom'
import { getPreselectedLanguage } from './translations/utils'

import { routeConfig, buildLinkForPath, buildRoutePathWithLang } from './routeConfig'

export default function Routes() {
  const preselectedLanguage = getPreselectedLanguage()

  return (
    <Switch>
      {routeConfig.map(({ path, Component, exact }) => (
        <Route key={path} path={buildRoutePathWithLang(path)} exact={exact}>
          <Component />
        </Route>
      ))}

      <Route exact path="/">
        <Redirect to={buildLinkForPath('/', preselectedLanguage)} />
      </Route>
    </Switch>
  )
}
